export const DEFAULT_SNAP_DATA = {
  x: null,
  y: null,
  width: null,
  height: null,
};
